module.exports = __webpack_public_path__ + "static/img/son2_active.8d63c4b0.png";